<template>
  <span>
    <el-dialog
    title="编辑"
    :visible.sync="editDetailFlag"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :fullscreen="dialogFull"
    @close="editForm={};tableData=[];"
    append-to-body
    width="65%">
    
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{"编辑"}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
        <!-- <div>新增详情：{{query.projectId}}</div> -->
        <avue-form ref="editForm" 
        style="height: 50vh;overflow: scroll;" 
        v-if="editDetailFlag" v-model="editForm" :option="option" @reset-change="emptytChange" @submit="submit">
            
   <template slot-scope="{}" slot="checkItemLabel">
       <div>{{' '}}</div>
   </template>
   <template slot-scope="scope" slot="userIdList">
       <!-- :limit="1" -->
              <UserEditBox2
                v-model="editForm.userIdList"
                :placeholder.sync="placeholder"
                :remainUserListInside.sync="remainUserList"
                :projectId="editForm.projectId"
                :disabled="pageMode == 0"
              />
   </template>
            <template slot-scope="{}" slot="checkItem">
                <div>
                    <el-table border :data="tableData" height="300">
                        <el-table-column
                        align="center"
                        header-align="center"
                        label="#"
                        type="index">
                        </el-table-column>
                        <el-table-column
                        prop="content"
                        label="标准内容"
                        width="280">
                        </el-table-column>
                        <el-table-column
                        prop="demand"
                        label="考核要求"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="score"
                        label="分值">
                        </el-table-column>
                        <el-table-column
                        prop="baseScore"
                        label="基准分值">
                        </el-table-column>
                    </el-table>
                </div>
            </template>
            
  <template slot-scope="scope" slot="projectId">

        <el-select
          v-model="editForm.projectId" 
          clearable 
          :disabled="true"
          @change="projectChange"
        >
          <el-option
            v-for="(item,index) in projectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
            
          </el-option>
        </el-select>
  </template>
  <template slot-scope="scope" slot="objectType">

        <el-select
          :disabled="true"
          v-model="editForm.objectType" 
          clearable 
          @change="objectTypeChange"
        >
          <el-option
            v-for="(item,index) in objectTypeList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          >
            
          </el-option>
        </el-select>
  </template>
  <template slot-scope="scope" slot="standardId">

        <el-select
          v-model="editForm.standardId" 
          clearable 
          @change="standardIdChange"
        >
          <el-option
            v-for="(item,index) in standardIdList"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
            
          </el-option>
        </el-select>
  </template>
  
  <!-- <template slot="menuForm">
    <el-button  icon="el-icon-delete" @click="editForm={};tableData=[];handleClose();">取 消</el-button>
  </template> -->
        </avue-form>
        
                <template slot="footer">
                        <el-divider></el-divider>
                        <div>
                              <el-button icon="el-icon-circle-plus-outline" :disabled="submitDisabledFlag" @click="submit" size="small" type="primary">{{ title=="新 增"?'保 存':'修 改' }}</el-button>  
                              <el-button icon="el-icon-circle-close" style="margin-right:10px" size="small" @click="editForm={};tableData=[];handleClose();">取 消</el-button>
                        </div>
                </template>
    </el-dialog>
        <el-button
            type="text"
            size="small"
            icon=""
            style="padding:0 .1rem"
            @click="editDetailFlag=true;initPage()"
        >
          编辑
        </el-button>
  </span>
</template>

<script>
import { add, getAllUserByTaskId, getDetail, getList, remove, update, getProjectDic,getStandardNameList,getStandardInfo,getStandardDetailList } from '@/api/v4ward/assess/task/assesstask';
import {getProjectList} from "@/api/crmedical/group/group";
        import { getDictionary } from '@/api/common';
import UserEditBox2 from "@/views/components/user-edit-box2";
import dayjs from 'dayjs';
export default {
    
  components: { UserEditBox2 },
  props: {
    query: {
      default: ()=>{}, //项目id
    },
    row: {
      default: ()=>{}, //项目id
    },
  },

    data(){
        let disabled = false;
        return{
          standardIdList:[],
          objectTypeList:[],
            pageMode:1,
            remainUserList:[],
            editForm:{},
            editDetailFlag:false,
            submitDisabledFlag:false,
            tableData:[],
      option: {
        //   mockBtn:true,
          submitText: '保存',
          cancelBtn:false,
          submitBtn:false,
        emptyBtn:false,
        //   printBtn:true,
        column: [
          // {
          //   label: '主键',
          //   prop: 'id',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入主键',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            // label: '项目id',
            disabled: disabled,
            label: '项目名称',
            prop: 'projectId',
            searchValue:'66666',
            type:'select',
              formslot:true,
            span:8,
            props:{
              label:'name',value:'id'
            },
            // bind:'query.projectId',
            // change:(value,column)=>{
            //   console.log(value,column);
            //   this.editForm.projectId = value.value;
            //   if(value.value){
            //     // this.editForm.objectType = '';
            //     // this.editForm.standardId = '';
            //       this.getDicData(value.value);
            //   }
            // },
            // dicData:[],
            // bind:'query.projectId',
            // change:(value,column)=>{
            //   console.log(value,column);
            //   this.query.projectId = value.value;
            // },
            rules: [
              {
                required: true,
                message: '请输入项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            // label: "考核对象类型,取自项目字典project_assess_object_type",
            label: '考核对象',
            prop: 'objectType',
            search: true,
              formslot:true,
            span:8,
            type:'select',
            props:{
              label:'dictValue',value:'dictKey'
            },
            // dicData:[],
            // change:(value,column)=>{
            //   console.log(value,column);
            //   this.editForm.objectType = value.value;
            //     console.log("this.editForm.standardId====>",this.editForm.standardId);
            //   if(value.value){
            //     if(this.editForm.standardId){
            //       this.editForm.standardId = '';
            //     }
            //     this.getStandardNameData(value.value,this.editForm.projectId);
            //   }
            // },
            rules: [
              {
                required: true,
                // message: '请输入考核对象类型,取自项目字典project_assess_object_type',
                message: '请输入考核对象类型',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            // label: '标准id',
            label: '标准名称',
            prop: 'standardId',
              formslot:true,
            span:8,
            type:'select',
            props:{
              label:'name',value:'id'
            },
            // dicData:[],
            // change:(value,column)=>{
            //   console.log(value,column);
            //   this.editForm.standardId = value.value;
            //   if(value.value){
            //       this.getStandardInfoData(value.value);
            //       this.getStandardDetailListData(value.value);
            //   }
            // },
            rules: [
              {
                required: true,
                // message: '请输入标准id',
                message: '请输入标准名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '任务名称',
            prop: 'name',
            search: true,
            maxlength:'50',
            showWordLimit:true,
            type:'input',
            span:24,
            rules: [
              {
                required: true,
                message: '请输入任务名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: true,
            label: '总分',
            prop: 'totalScore',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入总分',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            label: '基准分',
            prop: 'baseScore',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入基准分',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            label: '合同名称',
            prop: 'contractName',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同名称',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            label: '合同编号',
            prop: 'contractCode',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同编号',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            display:false,
            label: '合同Id',
            prop: 'contractId',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同Id',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: disabled,
            // label: '通知方式（多选）：1-系统消息；2-短信；3-微信；',
            label: '通知方式',
            prop: 'systemNotifyWays_',
            span:8,
            type:'select',
            props:{
              label:'dictValue',value:'dictKey'
            },
            multiple:true,
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              if(value.value){
              this.editForm.systemNotifyWays = value.value.join(',');
              }
            //   this.getStandardInfoData(value.value);
            },
            rules: [
              {
                required: true,
                // message: '请输入通知方式（多选）：1-系统消息；2-短信；3-微信；',
                message: '请输入通知方式',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '任务时间',
            prop: 'taskTime',
            type: 'datetimerange',
            rangeSeparator:'至',
            startPlaceholder:'开始时间',
            endPlaceholder:'结束时间',
            span:16,
            valueFormat:'yyyy-MM-dd HH:mm:ss',
            format:'yyyy-MM-dd HH:mm:ss',
            defaultTime:['00:00:00','23:59:59'],
            change:(value,column)=>{
              console.log("任务时间===========>",value,column);
              if((value.value+'')&&((value.value+'')!=='null')){

                this.editForm.startTime = value.value[0];
                this.editForm.endTime = value.value[1];
              }
            //   this.getStandardInfoData(value.value);
            },
            rules: [
              {
                required: true,
                message: '请输入任务时间',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '考评人员',
            prop: 'userIdList',
              formslot:true,
            // type: 'datetime',
            span:16,
            rules: [
              {
                required: true,
                message: '请输入考评人员',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '备注',
            prop: 'description',
            type: 'textarea',
            maxlength:'200',
            span:24,
            showWordLimit:true,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入备注',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            label: '考核项目',
            prop: 'checkItem',
            // type: 'datetime',
              formslot:true,
            //   labelslot:true,
            labelPosition:'top',
            span:24,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入考评人员',
            //     trigger: 'change',
            //   },
            // ],
          },
        ],
      },
        }
    },

methods:{
  standardIdChange(val){
      // this.editForm = Object.assign({},this.editForm,{
      //   standardId:val
      // });
      console.log(this.editForm);
      this.getStandardInfoData(val);
                  this.getStandardDetailListData(val);
  },
  objectTypeChange(val){
      setTimeout(()=>{
        this.editForm = Object.assign({},this.editForm,{
          standardId:''
        });
        console.log(this.editForm);
        this.getStandardNameData(val,this.editForm.projectId);
      })
  },
    projectChange(val){
      setTimeout(()=>{
        this.editForm = Object.assign({},this.editForm,{
          objectType:'',
          standardId:''
        });
        console.log(this.editForm);
        this.getDicData(val);
      })
      // this.query.projectId = val;
      // this.query = Object.assign({},this.query,{
      //   projectId:val,
      //   workStatus:'',
      //   objectType:''
      // });
      // this.getSearchDicData(val);
    },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                
                                        self.editDetailFlag = false;
                                if(done){
                                        // this.selectTimeFlag = false;

                                }else{
                                        // this.selectTimeFlag = false;
                                }
                                        // done();
                        })
                        .catch(()=> {
                                
                        });
                },
    submit(done){
      if(this.submitDisabledFlag){
        return;
      }
      this.submitDisabledFlag = true;
      this.$refs.editForm.validate((valid)=>{
        if(valid){
          this.editForm.startTime = dayjs(this.editForm.startTime).format('YYYY-MM-DD HH:mm:ss');
          this.editForm.endTime = dayjs(this.editForm.endTime).format('YYYY-MM-DD HH:mm:ss');
          this.editForm.id = this.row.id;
          update(this.editForm).then((res)=>{
              console.log(res.data);
              this.$message.success('操作成功！');
              this.$emit('refreshAction');
              this.editDetailFlag = false;
              this.editForm = {};
              this.submitDisabledFlag = false;
              if(done){
                  done();
              }
          }).catch((err)=>{
              this.submitDisabledFlag = false;
            // this.$message.error(err.msg);
          });
        }else{
          this.submitDisabledFlag = false;
        }
      })
    },
    getAllUserByTaskIdData(taskId){
        getAllUserByTaskId({taskId:taskId}).then((res)=>{
            console.log(res.data);
            let arr = res.data.map(item => item.userId);
            this.editForm.userIdList = arr.join(',');
            this.remainUserList = res.data.map(item => {return {id:item.userId,realName:item.userName+"("+item.deptName+")"}});
        })
    },
    getStandardDetailListData(standardId){
        getStandardDetailList({standardId:standardId}).then((res)=>{
            this.tableData = res.data;
            console.log("this.tableData=======>",this.tableData);
            this.editForm.checkItem = res.data;
        });
    },
    getStandardInfoData(standardId){
        getStandardInfo({id:standardId}).then((res)=>{
            console.log(res);
            this.editForm.contractName = res.data.contractName;
            this.editForm.contractCode = res.data.contractCode;
            this.editForm.contractId = res.data.contractId;
            this.editForm.baseScore = res.data.baseScore;
            this.editForm.totalScore = res.data.totalScore;
        })
    },
    getStandardNameData(objectType,projectId){
        getStandardNameList({objectType:objectType,projectId:projectId}).then((res)=>{
            // this.setSearchFormDic('standardId',res.data);
            this.standardIdList = res.data;
        });
    },
    initPage(){
        console.log("this.$ref.editForm====>",this.$refs.editForm);
        // this.editForm.projectId = this.query.projectId;
        getProjectList().then((res)=>{
        console.log(res);
        this.projectList = res.data;
        this.editForm.projectId = this.row.projectId;
        this.editForm.objectType = this.row.objectType+'';
        this.editForm.standardId = this.row.standardId+'';
        this.editForm.systemNotifyWays_ = this.row.systemNotifyWays.split(',');
        this.editForm.description = this.row.description;
        this.editForm.taskTime = [new Date(this.row.startTime),new Date(this.row.endTime)];
        this.editForm.name = this.row.name;
        // console.log(this.editForm.systemNotifyWays_);
            // this.setSearchFormValue('crud','projectId',res.data[0].id);
            // this.setSearchFormDic('projectId',res.data);
            this.getDicData(this.row.projectId);
            this.getAllUserByTaskIdData(this.row.id);
            this.getStandardNameData(this.editForm.objectType,this.editForm.projectId);
            this.getStandardInfoData(this.editForm.standardId);
            this.getStandardDetailListData(this.editForm.standardId);
        });
    },
    getDicData(projectId){
      getProjectDic({projectId:projectId,code:'project_examine_service_type'}).then((res)=>{
        // this.setSearchFormDic('objectType',res.data);
        this.objectTypeList = res.data;
      });
    //   system_notify_way
    getDictionary('system_notify_way').then((res)=>{
        this.setSearchFormDic('systemNotifyWays_',res.data);
      });
    //   getDictionary('assess_task_work_status').then((res)=>{
    //     this.setSearchFormDic('workStatus',res.data);
    //   });
    },
    setSearchFormDic(prop,list){
      const column = this.findObject(this.option.column, prop);
      column.dicData = list;
    },
    setSearchFormValue(ref,prop,value){
        setTimeout(()=>{
          this.$refs[ref].$refs.headerSearch.$refs.form.form[prop] = value;
        });
    },
},


}
</script>


<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>